import * as stylex from '@stylexjs/stylex'
import {
  typographyColor as color,
  fontFamilies,
  fontSizes,
  fontWeights,
  letterSpacing,
} from './tokens.stylex'

export const typography = stylex.create({
  body: {
    fontFamily: fontFamilies.paragraph,
    fontFeatureSettings: '"salt"',
    lineHeight: '1.5',
    fontSize: fontSizes.body,
    fontWeight: fontWeights.regular,
    letterSpacing: letterSpacing.reg,
    color: color.neutralBase,
  },
  label: {
    fontFamily: fontFamilies.paragraph,
    fontFeatureSettings: '"salt"',
    lineHeight: '1.5',
    fontSize: fontSizes.body,
    fontWeight: fontWeights.regular,
    letterSpacing: letterSpacing.reg,
    color: color.brandLabel,
  },
  small: {
    fontFamily: fontFamilies.paragraph,
    fontFeatureSettings: '"salt"',
    lineHeight: '1.5',
    fontSize: fontSizes.small,
    fontWeight: fontWeights.regular,
    letterSpacing: '0.25px',
    color: color.neutralBase,
  },
  eyebrowRegular: {
    fontFamily: fontFamilies.paragraph,
    fontFeatureSettings: '"salt"',
    lineHeight: '1.5',
    fontSize: fontSizes.body,
    fontWeight: fontWeights.bold,
    letterSpacing: letterSpacing.space,
    textTransform: 'uppercase',
    color: color.brandLabel,
  },
  eyebrowSmall: {
    fontFamily: fontFamilies.paragraph,
    fontFeatureSettings: '"salt"',
    lineHeight: '1.5',
    fontSize: fontSizes.small,
    fontWeight: fontWeights.bold,
    letterSpacing: letterSpacing.xspace,
    textTransform: 'uppercase',
    color: color.brandLabel,
  },

  heading1: {
    fontFamily: fontFamilies.paragraph,
    fontFeatureSettings: '"salt"',
    lineHeight: '1.33',
    fontSize: fontSizes.fs80,
    fontWeight: fontWeights.bold,
    letterSpacing: letterSpacing.cosy,
    color: color.neutralPrimaryHeading,
  },
  heading2: {
    fontFamily: fontFamilies.paragraph,
    fontFeatureSettings: '"salt"',
    lineHeight: '1.33',
    fontSize: fontSizes.fs70,
    fontWeight: fontWeights.bold,
    letterSpacing: letterSpacing.cosy,
    color: color.neutralPrimaryHeading,
  },
  heading3: {
    fontFamily: fontFamilies.paragraph,
    fontFeatureSettings: '"salt"',
    lineHeight: '1.33',
    fontSize: fontSizes.fs60,
    fontWeight: fontWeights.bold,
    letterSpacing: letterSpacing.reg,
    color: color.neutralSecondaryHeading,
  },
  heading4: {
    fontFamily: fontFamilies.paragraph,
    fontFeatureSettings: '"salt"',
    lineHeight: '1.33',
    fontSize: fontSizes.body,
    fontWeight: fontWeights.bold,
    letterSpacing: letterSpacing.reg,
    color: color.neutralSecondaryHeading,
  },
  display1: {
    fontFamily: fontFamilies.heading,
    lineHeight: '1.25',
    fontSize: fontSizes.fs100,
    fontWeight: fontWeights.semibold,
    letterSpacing: letterSpacing.xcosy,
    color: color.brandPrimaryHeading,
  },
  display2: {
    fontFamily: fontFamilies.heading,
    lineHeight: '1.25',
    fontSize: fontSizes.fs90,
    fontWeight: fontWeights.semibold,
    letterSpacing: letterSpacing.cosy,
    color: color.brandPrimaryHeading,
  },
})
